import Tag from './Tag';
import { Tooltip } from 'reactstrap';
import { useState } from 'react';

export default function TagsList({ tags }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <div>
            {tags.slice(0, 3).map((tag) => (
                <Tag name={tag?.tagName} colour={tag?.colour} description={tag?.description} disabled={tag?.disabled} />
            ))}
            {tags.length > 3 &&
                <>
                    <i className="bi bi-three-dots" id="Tags"></i>
                    <Tooltip
                        placement="top"
                        isOpen={tooltipOpen}
                        target="Tags"
                        toggle={toggle}
                    >
                        {tags.map(m => m.tagName).join(', ')}
                    </Tooltip>
                </>
            }
        </div>
    );
}